import React from 'react';
import PropTypes from 'prop-types';

const Contents = ({ color, width, height, ariaLabel }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    aria-labelledby="title"
  >
    <title id="title">{ariaLabel}</title>
    <g
      fill="none"
      fillRule="evenodd"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1 3H23V21H1z" />
      <path d="M9 16L9 8 16 12z" />
    </g>
  </svg>
);

Contents.defaultProps = {
  ariaLabel: '',
};

Contents.propTypes = {
  ariaLabel: PropTypes.string,
  color: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

export default Contents;
